var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}},[_c('client-only',[(_vm.activeStore)?_c('GoogleMap',{ref:"map",attrs:{"lat":Number(_vm.activeStore?.coordinates?.lat),"lng":Number(_vm.activeStore?.coordinates?.lng),"mapZoom":_vm.zoom,"shops":_vm.stores,"iframe":_vm.activeStore?.iframe}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }